import { Agreement } from './agreement';

export interface AgreementItem {
  agreement: Agreement;
  agreementItemCode: string;
  agreementItemId: number;
}
